// Hosted Flow Beta (central worker) — mode run per-browser. localStorage SAHAJA.
// mode: 'hosted' (lalai, PC ofis) | 'biasa' (extension Chrome lama). Kelayakan disahkan SERVER
// (/quota.eligible) — mode ini cuma pilihan rupa; bukan-layak → komponen render null.
// ⛔ Tiada kuki / kata laluan / token. Tulis HANYA dalam handler (bukan useEffect — perangkap StrictMode).
const KUNCI_SIMPAN = 'sesaat_hosted_beta_v1';
const LALAI = Object.freeze({ mode: 'hosted' });

export function bacaHostedBeta() {
  try {
    const r = JSON.parse(localStorage.getItem(KUNCI_SIMPAN) || 'null');
    return r && typeof r === 'object' ? { ...LALAI, ...r } : { ...LALAI };
  } catch { return { ...LALAI }; }
}

export function simpanHostedBeta(next) {
  const v = { ...LALAI, ...(next || {}) };
  try { localStorage.setItem(KUNCI_SIMPAN, JSON.stringify(v)); } catch { /* abai */ }
  return v;
}
